<template>
	<main class="payment-result">
		<div class="payment-result__inner _cnt">
			<duv class="payment-result__title _md">
				{{
					$t(
						'Unfortunately, we were unable to process your payment. Please try again later'
					)
				}}
			</duv>
		</div>
	</main>
</template>

<script>
import { ButtonThemes } from '@/components/base/BaseButton.vue';

export default {
	name: 'PaymentFailPage',
	components: {},
	props: [],
	data: function () {
		return {
			ButtonThemes,
		};
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.payment-result {
	@include adaptiveValue('padding-top', 50, 25);
	@include adaptiveValue('padding-bottom', 50, 20);
	@include header-indent;
	&__inner {
	}

	&__title {
		display: block;
		text-align: center;
		span {
			color: var(--secondary-color);
		}
	}
}
</style>
